<template>
  <div id="driveFileList">
    <md-toolbar>
      <md-input-container class="filter" style="flex: 1;">
        <label>Filter</label>
        <md-input v-model="filter"></md-input>
      </md-input-container>
      <md-button class="md-icon-button" @click="create">
        <md-icon>add</md-icon>
        <md-tooltip md-direction="bottom">Create new file</md-tooltip>
      </md-button>
      <md-button class="md-icon-button" @click="refresh">
        <md-icon class="status-icon md-primary" :class="{ 'pending': refreshStatus === 'pending' }">refresh</md-icon>
        <md-tooltip md-direction="bottom">Refresh the file list</md-tooltip>
      </md-button>
    </md-toolbar>
    <md-list class="md-double-line file-list">
      <DriveFileListItem v-for="file in filteredFiles" :key="file.id" :file="file"></DriveFileListItem>
    </md-list>
  </div>
</template>

<script>
  import Vue from 'vue';

  import DriveFileListItem from './DriveFileListItem';

  export default {
    name: 'driveFileList',

    components: {
      DriveFileListItem,
    },

    data() {
      return {
        refreshStatus: '',
        files: [],
        filter: '',
      };
    },

    computed: {
      filteredFiles() {
        return this.files.filter(file => file.name.match(this.checkRegex(this.filter)));
      },
    },

    mounted() {
      this.refreshStatus = '';
      this.getFiles();
      this.$events.on('file-delete', (file) => {
        let index = -1;
        this.files.forEach((elt, i) => {
          if (elt.id === file.id) { index = i; }
        });
        if (index >= 0) {
          this.files.splice(index, 1);
        }
      });
    },

    methods: {
      checkRegex(string) {
        try {
          return new RegExp(string);
        } catch (e) {
          return '';
        }
      },

      getFiles() {
        this.refreshStatus = 'pending';
        const q = "mimeType = 'text/markdown'";
        Vue.googleDrive.files(q, '*').then((response) => {
          if (response.status !== 200) {
            // @ToDo Do something with errors.
            this.refreshStatus = 'error';
          } else if (response.result !== undefined && response.result.files !== undefined) {
            this.files = response.result.files;
            this.refreshStatus = '';
          }
        });
      },

      refresh() {
        this.getFiles();
      },

      create() {
        this.files.push({
          name: '',
          isNew: true,
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../assets/theme';

  #driveFileList {
    max-width: 320px;
  }

  .md-theme-default {
    &.md-toolbar {
      background: lighten($black, 15%);
      font-size: 1rem;
    }
    &.md-list.file-list {
      background: lighten($black, 20%);
      height: calc(100% - 64px);
      overflow-y: auto;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/DriveFileList.vue?506f4eb1